import CardGallery from "/components/CardGallery/CardGallery";

export default CardGallery;
